import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { BQLink } from '../../../../atoms/bqlink';
import { widgetLink } from '../../../../../helpers/utils';
import { OpenInNewIcon } from '../../../../atoms/material-icons';
import SearchStocks from '../../component/search-stocks';
import './stock.m.css';

const StockPageHeader = (props) => {
  const widgetParam = props?.widget ? '?view=apps' : '';
  const [initialLoading, setInitialLoading] = useState(true);
  const [isWidgetPage, setIsWidgetPage] = useState(false);

  useEffect(() => {
    window.location.pathname.startsWith('/widget') ? setIsWidgetPage(true) : setIsWidgetPage(false);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  if (initialLoading) {
    return <div styleName="initial-loading-container mp-header" className="section-fluid"></div>;
  }

  return (
    <div styleName="mp-header" className="section-fluid">
      <div styleName="mp-header-content" className="container">
        <div styleName="header-container">
          {!isWidgetPage ? (
            <div styleName="back-navigation">
              <BQLink href={widgetLink(`/markets${widgetParam}`, props?.widget)}>
                <span styleName="back-text">&lt; Back</span>
              </BQLink>
              <span styleName="stock-name">{props?.myStock?.COMPNAME}</span>
            </div>
          ) : null}
          <div styleName="header-btn-container">
            <BQLink
              styleName="header-btn"
              href={widgetLink(`/markets/futures-contract${widgetParam}`, props?.widget)}
              target="_blank"
              rel="noreferrer"
            >
              Futures <OpenInNewIcon color={'#d01e51'} styleName="tab-icon" />
            </BQLink>
            <BQLink
              styleName="header-btn"
              href={widgetLink(`/markets/option-chain${widgetParam}`, props?.widget)}
              target="_blank"
              rel="noreferrer"
            >
              Options <OpenInNewIcon color={'#d01e51'} styleName="tab-icon" />
            </BQLink>
          </div>

          <div styleName="search-box">
            <SearchStocks widget={props?.widget} />
          </div>
        </div>
      </div>
    </div>
  );
};

StockPageHeader.propTypes = {
  myStock: PropTypes.object.isRequired,
};

export default StockPageHeader;
